import * as React from 'react';

export interface IAuthPageRightSectionProps extends React.PropsWithChildren {}

export const AuthPageRightSection: React.FunctionComponent<
  IAuthPageRightSectionProps
> = props => {
  return (
    <div className='py-8 lg:p-8'>
      <div className='mx-auto flex w-full flex-col justify-center space-y-6'>
        {props.children}
      </div>
    </div>
  );
};
